import { call, put, takeEvery } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import * as offerActions from 'modules/configurator/actions/offers';
import * as actionTypes from 'modules/configurator/actionTypes';
import { createNotification } from 'modules/toast-notifications/actions';
import { downloadFile } from 'services/Utils';

function* getPdfOffer({ payload }) {
  const { request, id, filename: fileName } = payload;

  try {
    const { data: file } = yield call(restClient.request, request);
    yield call(downloadFile, file, { type: 'application/pdf', fileName });
    yield put(offerActions.getPdfOfferSuccess(id));
  } catch (error) {
    yield put(offerActions.getPdfOfferFailure(error, id));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'http.error.message',
          defaultMessage: 'Oops! Something went wrong.',
        },
      })
    );
  }
}

export default function* generalSagas() {
  yield takeEvery(actionTypes.FETCH_OFFER_PDF_REQUEST, getPdfOffer);
}
